import Auth from 'contexts/auth'

const useConfirmed = () => {
  const { auth } = Auth.useContainer()
  return auth?.user.confirmed || false
}

export default useConfirmed
